import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NordicWalkingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"nordic_walking"}/>
}
